import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  input,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { SubscriptionLike, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CONFIG } from '../../helper/app-config';

@Component({
  selector: 'app-admin-guidelines-input',
  templateUrl: './admin-guidelines-input.component.html',
  styleUrl: './admin-guidelines-input.component.css',
})
export class AdminGuidelinesInputComponent {
  dataSource = new MatTableDataSource();
  dataSource2 = new MatTableDataSource();
  dataSources_forCooler = [this.dataSource, this.dataSource2];
  @Output() checkNpdsValidationInGuidelines = new EventEmitter();
  columns = ['no', 'dropdown', 'sku_min_face', 'sku_max_face'];
  columns_when_not_stills = ['no', 'dropdown', 'sku_facings'];
  data = [{ sku_img: 'sku1', sku_name: 'coco cola', sku_face: 3 }];
  guidelines_input_subscribtion: SubscriptionLike;
  categories = ['ONS', 'UF', 'Strategic', 'Mandatory', 'Stills', 'NPD'];
  admin_guidelines_input_observable: Observable<any> =
    this.planogramState.versioned_guidelines_data;
  admin_guidelines_input: any = {};
  selectedCategory = 'ONS';
  npds_dropdown_value: any = [];
  npds_dropdown_selected: any = [];
  selected_npds_from_data: any = [];
  npd_max_facings: number;
  npd_min_facings: number;
  npd_description: string;
  planogram_id: number;
  isLibrary: boolean = false;
  admin_guidelines_for_ONS: any = [];
  admin_guidelines_for_UF: any = [];
  admin_guidelines_for_strategy: any = [];
  admin_guidelines_for_mandatory: any = [];
  admin_guidelines_for_stills: any = [];
  admin_guidelines_for_npd: any = [];
  admin_guidelines_options_for_ONS: any = [];
  admin_guidelines_options_for_UF: any = [];
  admin_guidelines_options_for_strategy: any = [];
  admin_guidelines_options_for_mandatory: any = [];
  admin_guidelines_options_for_stills: any = [];
  admin_guidelines_options_for_npd: any = [];
  no_of_coolers: any;
  admin_guidelines_for_category: any = {
    ONS: this.admin_guidelines_for_ONS,
    UF: this.admin_guidelines_for_UF,
    Strategic: this.admin_guidelines_for_strategy,
    Mandatory: this.admin_guidelines_for_npd,
    Stills: this.admin_guidelines_for_stills,
    NPD: this.admin_guidelines_for_npd,
  };
  admin_guidelines_dropdown_options: any = {
    ONS: this.admin_guidelines_options_for_ONS,
    UF: this.admin_guidelines_options_for_UF,
    Strategic: this.admin_guidelines_options_for_strategy,
    Mandatory: this.admin_guidelines_options_for_npd,
    Stills: this.admin_guidelines_options_for_stills,
    NPD: this.admin_guidelines_options_for_npd,
  };
  @Input() payload = {};
  @Input() is_display = false;
  channel: string = '';
  cooler: string = '';
  version: number = 0;
  unit: string = '';
  flavour: string[] = [];
  pack_size: string[] = [];
  selectedFlavour: string[] = [];
  allFlavoursSelected: boolean = true;
  allPackSizesSelected: boolean = true;
  selectedPackSize: string[] = [];
  guideline_version_name: string;
  guidelines_data_for_coolers: any = {};
  npds_data: any = {};
  npds_data_options: any = {};
  constructor(
    private planogramState: PlanogramStateService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.channel = localStorage.getItem('admin_channel') || '';
      this.cooler = localStorage.getItem('admin_cooler') || '';
      this.version = Number(localStorage.getItem('admin_version'));
      this.unit = localStorage.getItem('admin_unit') || '';
      this.guideline_version_name =
        localStorage.getItem('guideline_version_name') || '';
      // const payload =
      //   this.router.getCurrentNavigation()?.extras?.state?.['payload'] || {};
      this.planogramState.getVersionedGuidelines({
        channel: this.channel,
        cooler_type: this.cooler,
        version: this.version,
        unit: this.unit,
      });
    });
  }
  ngOnInit(): void {
    // if (!this.admin_guidelines_input) {
    //   this.planogramState.getGuidelinesInput();
    // }
    this.guidelinesSuscription();
  }

  guidelinesSuscription() {
    this.guidelines_input_subscribtion =
      this.admin_guidelines_input_observable.subscribe((res) => {
        if (!res?.guidelines_data) return;

        this.admin_guidelines_input = res.guidelines_data;
        this.no_of_coolers = Object.keys(this.admin_guidelines_input);

        // Initialize guidelines data for coolers
        this.guidelines_data_for_coolers =
          this.guidelines_data_for_coolers || {};

        this.no_of_coolers.forEach((cooler: string, i: number) => {
          this.guidelines_data_for_coolers[cooler] =
            this.guidelines_data_for_coolers[cooler] || {};

          this.categories.forEach((cat) => {
            if (cat === 'NPD') return;

            this.guidelines_data_for_coolers[cooler][cat] =
              this.guidelines_data_for_coolers[cooler][cat] ||
              this.admin_guidelines_input[cooler].filter(
                (data: any) => data.group === cat
              );
          });

          this.dataSources_forCooler[i].data =
            this.guidelines_data_for_coolers[cooler][this.selectedCategory];
        });
        this.processNpdOptions(res);
        this.checkNpdsValidation();
      });
  }

  processNpdOptions(res: any) {
    const options = res.NPDs.NPDs.map((v: any) => ({ ...v, facings: 0 }));

    this.npd_max_facings = res.NPDs.maximum_facings;
    this.npd_min_facings = res.NPDs.minimum_facings;
    this.npd_description = res.note.NPD.description;

    const no_of_dropdowns = this.npd_max_facings / this.npd_min_facings;
    this.npds_data = Array.from({ length: no_of_dropdowns }, () => ({
      facings: 0,
      min_facings: 0,
      product_name: '',
    }));

    this.npds_data_options = options;
  }

  changeDropdownValue(option: any, position: number) {
    let selected_dropdown_option: any = [...option];
    selected_dropdown_option.min_facings = 0;
    selected_dropdown_option.max_facings = 0;
    this.admin_guidelines_for_category[this.selectedCategory][position] =
      selected_dropdown_option;
    this.dataSource.data =
      this.admin_guidelines_for_category[this.selectedCategory];
  }

  setFlavourAndSizeFilters(cat: string) {
    if (cat == 'ONS' || cat == 'UF') {
      this.admin_guidelines_dropdown_options[cat].forEach((data: any) => {
        if (data.category) {
          if (!this.flavour.includes(data.category)) {
            this.flavour.push(data.category);
          }
        }
        if (data.pack_segment_revised) {
          if (!this.pack_size.includes(data.pack_segment_revised)) {
            this.pack_size.push(data.pack_segment_revised);
          }
        }
      });
      this.selectedFlavour = this.flavour;
      this.allFlavoursSelected = true;
      this.allPackSizesSelected = true;
      this.selectedPackSize = this.pack_size;
    }
  }

  changeCategory(category: string) {
    console.log('category', category);
    this.selectedCategory = category;
    if (category == 'NPD') {
      this.dataSource.data = this.npds_data;
      this.dataSource2.data = [];
    } else {
      this.no_of_coolers.forEach((cooler: string, index: number) => {
        let filtered_data_based_on_category =
          this.guidelines_data_for_coolers[cooler][this.selectedCategory];
        this.dataSources_forCooler[index].data =
          filtered_data_based_on_category;
      });
    }
  }

  minDecrementFacings(cooler: string, data: any, i: number) {
    if (data.min_facings > 0) {
      let decrement = data.min_facings - 1;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].min_facings = decrement;
      this.dataSource.data =
        this.guidelines_data_for_coolers[cooler][this.selectedCategory];
    }
  }

  minIncrementFacings(cooler: string, data: any, i: number) {
    if (data.min_facings < 6) {
      let increment = data.min_facings + 1;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].min_facings = increment;
      this.dataSource.data =
        this.guidelines_data_for_coolers[cooler][this.selectedCategory];
    }
  }

  maxDecrementFacings(cooler: string, data: any, i: number) {
    if (data.max_facings > 0) {
      let decrement = data.max_facings - 1;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].max_facings = decrement;
      this.dataSource.data =
        this.guidelines_data_for_coolers[cooler][this.selectedCategory];
    }
  }

  maxIncrementFacings(cooler: string, data: any, i: number) {
    if (data.max_facings > 0) {
      let increment = data.max_facings + 1;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].max_facings = increment;
      this.dataSource.data =
        this.guidelines_data_for_coolers[cooler][this.selectedCategory];
    }
  }

  incrementFacings(cooler: string, data: any, i: number) {
    if (data.min_facings < 6) {
      let increment = data.min_facings + 1;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].min_facings = increment;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].max_facings = increment;
      this.dataSource.data =
        this.guidelines_data_for_coolers[cooler][this.selectedCategory];
    }
  }

  decrementFacings(cooler: string, data: any, i: number) {
    if (data.min_facings > 0) {
      let decrement = data.min_facings - 1;
      console.log('decrement', decrement);
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].min_facings = decrement;
      this.guidelines_data_for_coolers[cooler][this.selectedCategory][
        i
      ].max_facings = decrement;
      this.dataSource.data =
        this.guidelines_data_for_coolers[cooler][this.selectedCategory];
    }
  }

  checkNpdsValidation() {
    let valid = false;
    this.npds_data.forEach((npd: any) => {
      valid = true;
      if (npd.facings == 0) valid = true;
      else if (npd.facings < this.npd_min_facings) {
        valid = false;
        return;
      }
    });
    if (valid) {
      let sum = 0;
      this.npds_data.forEach((npd: any) => {
        sum = sum + npd.facings;
      });
      console.log('sum=========>', sum);
      if (sum === this.npd_max_facings) valid = true;
      else valid = false;
    }
    this.checkNpdsValidationInGuidelines.emit({ valid: valid });
  }

  renderHtml(value: string) {
    const boldTextPattern = /<b>(.*?)<\/b>/g;
    const segments = [];
    let lastIndex = 0;
    let match;

    // Extract segments, identifying <b> tags
    while ((match = boldTextPattern.exec(value)) !== null) {
      const beforeText = value.slice(lastIndex, match.index);
      const boldText = match[1];
      lastIndex = match.index + match[0].length;

      // Push regular text and bold text segments separately
      if (beforeText) segments.push({ text: beforeText, isBold: false });
      if (boldText) segments.push({ text: boldText, isBold: true });
    }

    // Add remaining text after the last match
    const afterText = value.slice(lastIndex);
    if (afterText) segments.push({ text: afterText, isBold: false });

    return segments;
  }

  createPlanogramVersion() {
    let payload: any = {};
    let updated_guidelines: any = {};
    this.no_of_coolers.forEach((cooler: string) => {
      let cooler_data = Object.values(this.guidelines_data_for_coolers[cooler]);
      let combined_array: any[] = [];
      cooler_data.forEach((d: any) => combined_array.push(...d));
      updated_guidelines[cooler] = combined_array;
    });
    payload.channel = this.channel;
    payload.unit = this.unit;
    payload.cooler_type = this.cooler;
    payload.NPDs = this.npds_data.map((v: any) => {
      let obj: any = {};
      obj.product_id = v.product_id;
      obj.product_name = v.product_name;
      obj.sku_image_uri = v.sku_image_uri;
      obj.facings = v.facings;
      return obj;
    });
    payload.min_facings = this.npd_min_facings;
    payload.max_facings = this.npd_max_facings;
    payload.version = this.version;
    payload.updated_guidelines = updated_guidelines;
    this.planogramState.createPlanogramVersion(payload);
  }

  selectNpds(npd: any, i: number) {
    this.npds_data[i] = { ...npd, facings: 2 };
    this.dataSource.data = this.npds_data;
    this.checkNpdsValidation();
    // this.admin_guidelines_for_category[this.selectedCategory][i] = {
    //   ...npd,
    //   facings: 2,
    // };
    // this.dataSource.data =
    //   this.admin_guidelines_for_category[this.selectedCategory];
    // this.checkNpdsValidation();
  }

  AllFlavorsToggle() {
    this.allFlavoursSelected = !this.allFlavoursSelected;
    if (this.allFlavoursSelected) {
      this.selectedFlavour = this.flavour;
    } else {
      this.selectedFlavour = [];
    }
    this.onFlavorAndPackSizeChange();
  }

  allPackSizesToggle() {
    this.allPackSizesSelected = !this.allPackSizesSelected;
    if (this.allPackSizesSelected) {
      this.selectedPackSize = this.pack_size;
    } else {
      this.selectedPackSize = [];
    }
    this.onFlavorAndPackSizeChange();
  }

  onFlavorAndPackSizeChange() {
    let FilteredData: any[] = [];
    if (this.selectedFlavour.length == this.flavour.length) {
      this.allFlavoursSelected = true;
      this.selectedFlavour = this.flavour;
    } else if (this.selectedFlavour.length === 0) {
      this.allFlavoursSelected = false;
    }
    if (this.selectedPackSize.length == this.pack_size.length) {
      this.allPackSizesSelected = true;
      this.selectedPackSize = this.pack_size;
    } else if (this.selectedPackSize.length === 0) {
      this.allPackSizesSelected = false;
    }
    FilteredData = this.admin_guidelines_for_category[
      this.selectedCategory
    ].filter(
      (data: any) =>
        this.selectedFlavour.includes(data.category) &&
        this.selectedPackSize.includes(data.pack_segment_revised)
    );

    this.dataSource.data = FilteredData;
  }

  // sumSameNameNpds() {
  //   let array: any = [];
  //   this.npds_dropdown_selected.forEach((npd: any) => {
  //     let duplicateIndex: any = -1;
  //     if (array.length > 0) {
  //       array.forEach((n: any, i: number) => {
  //         if (n.product_id == npd.product_id) {
  //           duplicateIndex = i;
  //         } else duplicateIndex = -1;
  //         console.log('dupliacate index', duplicateIndex);
  //       });
  //     }
  //     if (duplicateIndex !== -1) {
  //       let sum = array[duplicateIndex].facings + npd.facings;
  //       array[duplicateIndex] = { ...array[duplicateIndex], facings: sum };
  //     } else array.push(npd);
  //   });
  //   return array;
  // }

  // moveBack() {
  //   this.router.navigateByUrl(CONFIG.PATH.ADMIN_GUIDELINES_INPUT, {
  //     state: { screen_index: 0, screen: 'planogram-list' },
  //   });
  // }
}
